import { useTranslation as useI18nTranslation } from 'react-i18next';

import i18n from './i18n.js';
import type en from './locales/en/translation.js';

const PENDING = '__I18N_PENDING__:';

export type TranslationKey = keyof typeof en;

export function useTranslation(): {
  readonly t: (key: TranslationKey, values?: Record<string, string | number>) => string;
} {
  useI18nTranslation();

  const t = (key: TranslationKey, values?: Record<string, string | number>): string => {
    const raw = i18n.t(key, values ?? {});
    return raw.startsWith(PENDING) ? i18n.t(key, { ...values, lng: 'en' }) : raw;
  };

  return { t };
}
